<template>
  <div class="bpmn-content">
    <div class="containers" ref="container" id="containers">
      <div class="canvas" ref="canvas"></div>
      <div id="js-properties-panel" class="panel"></div>
    </div>
    <template v-if="isEdit">
      <el-button @click.native="save">保存</el-button>
      <remote-search :defaultData="defaultData" :options="fee_level_id" @input="nameChange" />
    </template>
  </div>
</template>

<script>
/* eslint-disable operator-linebreak */
/* eslint-disable max-len */

// 引入相关的依赖
import BpmnModeler from 'bpmn-js/lib/Modeler';
import Viewer from 'bpmn-js/lib/Viewer';
// import propertiesPanelModule from 'bpmn-js-properties-panel';
import propertiesProviderModule from 'bpmn-js-properties-panel/lib/provider/camunda';
// import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda.json';
import RemoteSearch from '@/components/common/RemoteSearch';
import { fee_level_id } from '@/utils/formConfigCommon';
import customTranslate from './customTranslate';

export default {
  name: 'BpmnComp',
  components: { RemoteSearch },
  props: {
    isEdit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    flowString: {
      type: String,
      default() {
        return `<?xml version="1.0" encoding="UTF-8"?>
        <bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" id="Definitions_1efy4dz" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.0.4">
          <bpmn:process id="Process_1fxnejv" isExecutable="false">
            <bpmn:startEvent id="StartEvent_1ni82mv" />
          </bpmn:process>
          <bpmndi:BPMNDiagram id="BPMNDiagram_1">
            <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1fxnejv">
              <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1ni82mv">
                <dc:Bounds x="156" y="81" width="36" height="36" />
              </bpmndi:BPMNShape>
            </bpmndi:BPMNPlane>
          </bpmndi:BPMNDiagram>
        </bpmn:definitions>`;
      }
    }
  },
  data() {
    return {
      // bpmn建模器
      bpmnModeler: null,
      container: null,
      canvas: null,
      defaultData: {},
      fee_level_id: {
        ...fee_level_id.options,
        key: 'fee_level_id'
      }
    };
  },
  watch: {
    flowString() {
      this.createNewDiagram(this.bpmnModeler);
    }
  },
  methods: {
    createNewDiagram() {
      const bpmnXmlStr = this.flowString;
      // 将字符串转换成图显示出来
      this.bpmnModeler.importXML(bpmnXmlStr, err => {
        if (err) {
          console.error(err);
        } else {
          // 这里还没用到这个，先注释掉吧
          // that.success()
          const eventBus = this.bpmnModeler.get('eventBus');
          // const events = [
          //   'element.hover',
          //   'element.out',
          //   'element.click',
          //   'element.dblclick',
          //   'element.mousedown',
          //   'element.mouseup'
          // ];
          eventBus.on('directEditing.activate', e => {
            // e.element = the model element
            // e.gfx = the graphical element
            console.log('activate', e.active.element);
          });
          eventBus.on('directEditing.deactivate', e => {
            // e.element = the model element
            // e.gfx = the graphical element
            console.log('deactivate', e);
          });
          document.getElementById('containers').addEventListener('input', e => {
            const tag = e.target;
            // tag.innerText = e.target.innerText + '11';
            console.log(tag.innerText);
          });
        }
      });
    },
    save() {
      this.bpmnModeler.saveXML({ format: true }, (err, xml) => {
        console.log(xml);
      });
    },
    nameChange(value, label) {
      console.log(value, label);
    }
  },
  mounted() {
    const { canvas, container } = this.$refs;
    this.container = container;
    const customTranslateModule = {
      translate: ['value', customTranslate]
    };
    let additionalModules = [];
    if (this.isEdit) {
      additionalModules = [
        // 左边工具栏以及节点
        propertiesProviderModule,
        // 右边的工具栏
        // propertiesPanelModule,
        // 翻译
        customTranslateModule
      ];
    } else {
      additionalModules = [
        // 翻译
        customTranslateModule
      ];
    }
    // 建模，官方文档这里讲的很详细
    if (this.isEdit) {
      this.bpmnModeler = new BpmnModeler({
        container: canvas,
        // 添加控制板
        propertiesPanel: {
          parent: '#js-properties-panel'
        },
        additionalModules
        // moddleExtensions: {
        //   camunda: camundaModdleDescriptor
        // }
      });
    } else {
      this.bpmnModeler = new Viewer({
        container: canvas
      });
    }

    this.createNewDiagram(this.bpmnModeler);
  }
};
</script>
<style lang="less">
/*左边工具栏以及编辑节点的样式*/
@import '../../../node_modules/bpmn-js/dist/assets/diagram-js.css';
@import '../../../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
@import '../../../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css';
@import '../../../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';
/*右边工具栏样式*/
// @import '../../../node_modules/bpmn-js-properties-panel/dist/assets/bpmn-js-properties-panel.css';
.bpmn-content {
  .containers {
    background-color: #ffffff;
    width: 1000px;
    height: 400px;
    overflow: hidden;
    border: 1px solid #8a8a8a;
    position: relative;
  }
  .canvas {
    width: 100%;
    height: 100%;
  }
  .panel {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px;
  }
  .bjs-powered-by {
    display: none;
  }
}
</style>
